export default {
  input: {
    background: '#fff',
    borderRadius: 4
  }
}
